import { createTranslations } from '@npco/utils-translations'

export const manageBusinessesTranslations = createTranslations({
  header: 'Businesses',
  addBusiness: 'Add Business',
  searchInput: 'businesses search input',
  placeholder: 'Search',
})
